import { render, staticRenderFns } from "./PsoriasisSpecificDataPhaseV2.vue?vue&type=template&id=153006c4&scoped=true&"
import script from "./PsoriasisSpecificDataPhaseV2.vue?vue&type=script&lang=js&"
export * from "./PsoriasisSpecificDataPhaseV2.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisSpecificDataPhaseV2.vue?vue&type=style&index=0&id=153006c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153006c4",
  null
  
)

export default component.exports